export default __webpack_public_path__ + "static/media/icon_dashboard.b8d86769.svg";